export default "__VITE_ASSET__CJxrmIGx__"